import { ApiMessage, ToolCallContent } from '@api/agentBuilder/chatmessage'
import { MESSAGE_TYPE_TOOL_CALL, MESSAGE_TYPE_TOOL_ERROR, MESSAGE_TYPE_TOOL_MESSAGE } from '@constants/agentTypes'
import { InternalMessage } from '@slices/userMessage'

export function apiMessageToInternalMessage(m: ApiMessage): InternalMessage {
  if (m.role === MESSAGE_TYPE_TOOL_CALL || m.role === MESSAGE_TYPE_TOOL_MESSAGE || m.role === MESSAGE_TYPE_TOOL_ERROR) {
    let im: InternalMessage
    try {
      im = (typeof m.content === 'string' ? JSON.parse(m.content) : m.content) as InternalMessage
    } catch {
      im = { type: m.role, value: m.content }
    }
    if (typeof im !== 'object' || im === null || !('data' in im)) {
      throw new Error('data is required for toolCall and toolMessage')
    }
    return {
      ...im,
      id: m.id,
      sessionId: m.sessionId,
      pendingApproval: m.pendingApproval,
      toolCallMessageId: m.role === MESSAGE_TYPE_TOOL_CALL ? m.id : im.toolCallMessageId,
      feedback: m.feedback ?? null,
      subTeammateChildSessionId: m.childSessionId ?? im.subTeammateChildSessionId,
      subTeammateChildChatflowName: m.childChatflowName ?? im.subTeammateChildChatflowName,
    }
  }
  return { id: m.id, type: m.role, value: m.content, chatFiles: m.chatFiles, sessionId: m.sessionId, feedback: m.feedback ?? null }
}

export function isToolCallContent(content: ApiMessage['content']): content is ToolCallContent {
  return typeof content === 'object' && content !== null && content.type === MESSAGE_TYPE_TOOL_CALL
}

export function getToolCallContent(message: ApiMessage): ToolCallContent | undefined {
  if (isToolCallContent(message.content)) {
    return message.content
  }

  if (typeof message.content === 'string') {
    try {
      const parsed = JSON.parse(message.content)
      return isToolCallContent(parsed) ? parsed : undefined
    } catch {
      return undefined
    }
  }

  return undefined
}
